export default "__VITE_ASSET__c1b9fb63__"